module.exports = __webpack_public_path__ + "static/media/IMG_20250111_112127.ba12ce5e.png";